/**
 * Password-related constants for the setup flow
 */

export const PASSWORD_CONSTANTS = {
  // Validation requirements
  MIN_LENGTH: 8,
  MAX_LENGTH: 500,
  MIN_SCORE: 70,

  // Score weights for different criteria
  SCORE_WEIGHTS: {
    LENGTH_BASE: 25,
    LENGTH_BONUS_12: 10,
    LENGTH_BONUS_16: 10,
    UPPERCASE: 20,
    LOWERCASE: 20,
    NUMBER: 20
  },

  // Score thresholds for strength levels
  THRESHOLDS: {
    STRONG: 90,
    GOOD: 70,
    FAIR: 50
  },

  // Debounce delay for validation (ms)
  VALIDATION_DEBOUNCE: 100,

  // Redirect delay after successful setup (ms)
  REDIRECT_DELAY: 3000
} as const;

export const PASSWORD_MESSAGES = {
  REQUIRED: 'Password is required',
  MIN_LENGTH: `Password must be at least ${PASSWORD_CONSTANTS.MIN_LENGTH} characters`,
  MAX_LENGTH: `Password must be at most ${PASSWORD_CONSTANTS.MAX_LENGTH} characters`,
  UPPERCASE: 'Password must contain at least one uppercase letter',
  LOWERCASE: 'Password must contain at least one lowercase letter',
  NUMBER: 'Password must contain at least one number',
  SPECIAL: 'Password must contain at least one special character',
  COMMON_PATTERNS: 'Password contains common patterns - please choose something more secure',
  SEQUENTIAL: 'Password cannot contain sequential characters (abc, 123, etc.)',
  REPEATED: 'Password cannot contain more than 2 consecutive identical characters',
  CONFIRM_REQUIRED: 'Please confirm your password',
  MISMATCH: 'The two passwords do not match',
  EXCELLENT: 'Excellent! Your password meets all security requirements.'
} as const;

export const PASSWORD_FEEDBACK = {
  REQUIRED: 'Enter a password',
  MIN_LENGTH: 'At least 8 characters',
  MAX_LENGTH: 'At most 500 characters',
  UPPERCASE: 'One uppercase letter',
  LOWERCASE: 'One lowercase letter',
  NUMBER: 'One number',
  SPECIAL: 'One special character',
  COMMON_PATTERNS: 'Avoid common patterns',
  SEQUENTIAL: 'Avoid sequential characters',
  REPEATED: 'Avoid repeated characters',
  EXCELLENT: 'Excellent! Your password meets all security requirements.'
} as const;
